"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useControllableReducer = useControllableReducer;
var React = _interopRequireWildcard(require("react"));
function areEqual(a, b) {
    return a === b;
}
var EMPTY_OBJECT = {};
var NOOP = function() {};
/**
 * Gets the current state augmented with controlled values from the outside.
 * If a state item has a corresponding controlled value, it will be used instead of the internal state.
 */ function getControlledState(internalState, controlledProps) {
    var augmentedState = _object_spread({}, internalState);
    Object.keys(controlledProps).forEach(function(key) {
        if (controlledProps[key] !== undefined) {
            augmentedState[key] = controlledProps[key];
        }
    });
    return augmentedState;
}
/**
 * Defines an effect that compares the next state with the previous state and calls
 * the `onStateChange` callback if the state has changed.
 * The comparison is done based on the `stateComparers` parameter.
 */ function useStateChangeDetection(parameters) {
    var nextState = parameters.nextState, initialState = parameters.initialState, stateComparers = parameters.stateComparers, onStateChange = parameters.onStateChange, controlledProps = parameters.controlledProps, lastActionRef = parameters.lastActionRef;
    var internalPreviousStateRef = React.useRef(initialState);
    React.useEffect(function() {
        if (lastActionRef.current === null) {
            // Detect changes only if an action has been dispatched.
            return;
        }
        var previousState = getControlledState(internalPreviousStateRef.current, controlledProps);
        Object.keys(nextState).forEach(function(key) {
            var _stateComparers_key;
            // go through all state keys and compare them with the previous state
            var stateComparer = (_stateComparers_key = stateComparers[key]) !== null && _stateComparers_key !== void 0 ? _stateComparers_key : areEqual;
            var nextStateItem = nextState[key];
            var previousStateItem = previousState[key];
            if (previousStateItem == null && nextStateItem != null || previousStateItem != null && nextStateItem == null || previousStateItem != null && nextStateItem != null && !stateComparer(nextStateItem, previousStateItem)) {
                var _lastActionRef_current_event, _lastActionRef_current_type;
                onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange((_lastActionRef_current_event = lastActionRef.current.event) !== null && _lastActionRef_current_event !== void 0 ? _lastActionRef_current_event : null, key, nextStateItem, (_lastActionRef_current_type = lastActionRef.current.type) !== null && _lastActionRef_current_type !== void 0 ? _lastActionRef_current_type : '', nextState);
            }
        });
        internalPreviousStateRef.current = nextState;
        lastActionRef.current = null;
    }, [
        internalPreviousStateRef,
        nextState,
        lastActionRef,
        onStateChange,
        stateComparers,
        controlledProps
    ]);
}
/**
 * The alternative to `React.useReducer` that lets you control the state from the outside.
 *
 * It can be used in an uncontrolled mode, similar to `React.useReducer`, or in a controlled mode, when the state is controlled by the props.
 * It also supports partially controlled state, when some state items are controlled and some are not.
 *
 * The controlled state items are provided via the `controlledProps` parameter.
 * When a reducer action is dispatched, the internal state is updated with the new values.
 * A change event (`onStateChange`) is then triggered (for each changed state item) if the new state is different from the previous state.
 * This event can be used to update the controlled values.
 *
 * The comparison of the previous and next states is done using the `stateComparers` parameter.
 * If a state item has a corresponding comparer, it will be used to determine if the state has changed.
 * This is useful when the state item is an object and you want to compare only a subset of its properties or if it's an array and you want to compare its contents.
 *
 * An additional feature is the `actionContext` parameter. It allows you to add additional properties to every action object,
 * similarly to how React context is implicitly available to every component.
 *
 * @template State - The type of the state calculated by the reducer.
 * @template Action - The type of the actions that can be dispatched.
 * @template ActionContext - The type of the additional properties that will be added to every action object.
 *
 * @ignore - internal hook.
 */ function useControllableReducer(parameters) {
    var lastActionRef = React.useRef(null);
    var reducer = parameters.reducer, initialState = parameters.initialState, _parameters_controlledProps = parameters.controlledProps, controlledProps = _parameters_controlledProps === void 0 ? EMPTY_OBJECT : _parameters_controlledProps, _parameters_stateComparers = parameters.stateComparers, stateComparers = _parameters_stateComparers === void 0 ? EMPTY_OBJECT : _parameters_stateComparers, _parameters_onStateChange = parameters.onStateChange, onStateChange = _parameters_onStateChange === void 0 ? NOOP : _parameters_onStateChange, actionContext = parameters.actionContext, _parameters_componentName = parameters.componentName, componentName = _parameters_componentName === void 0 ? '' : _parameters_componentName;
    var controlledPropsRef = React.useRef(controlledProps);
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(function() {
            Object.keys(controlledProps).forEach(function(key) {
                if (controlledPropsRef.current[key] !== undefined && controlledProps[key] === undefined) {
                    console.error("useControllableReducer: ".concat(componentName ? "The ".concat(componentName, " component") : 'A component', " is changing a controlled prop to be uncontrolled: ").concat(key));
                }
                if (controlledPropsRef.current[key] === undefined && controlledProps[key] !== undefined) {
                    console.error("useControllableReducer: ".concat(componentName ? "The ".concat(componentName, " component") : 'A component', " is changing an uncontrolled prop to be controlled: ").concat(key));
                }
            });
        }, [
            controlledProps,
            componentName
        ]);
    }
    // The reducer that is passed to React.useReducer is wrapped with a function that augments the state with controlled values.
    var reducerWithControlledState = React.useCallback(function(state, action) {
        lastActionRef.current = action;
        var controlledState = getControlledState(state, controlledProps);
        var newState = reducer(controlledState, action);
        return newState;
    }, [
        controlledProps,
        reducer
    ]);
    var _React_useReducer = _sliced_to_array(React.useReducer(reducerWithControlledState, initialState), 2), nextState = _React_useReducer[0], dispatch = _React_useReducer[1];
    // The action that is passed to dispatch is augmented with the actionContext.
    var dispatchWithContext = React.useCallback(function(action) {
        dispatch(_object_spread_props(_object_spread({}, action), {
            context: actionContext
        }));
    }, [
        actionContext
    ]);
    useStateChangeDetection({
        nextState: nextState,
        initialState: initialState,
        stateComparers: stateComparers !== null && stateComparers !== void 0 ? stateComparers : EMPTY_OBJECT,
        onStateChange: onStateChange !== null && onStateChange !== void 0 ? onStateChange : NOOP,
        controlledProps: controlledProps,
        lastActionRef: lastActionRef
    });
    return [
        getControlledState(nextState, controlledProps),
        dispatchWithContext
    ];
}
